import { useEffect, useState } from "react";
import { env } from "../config/env";

const DEFAULT_FAVICON_HREF = "/favicon.svg";

function brandingUrl(companyCode: string, asset: "logo" | "favicon"): string {
  return `${env.apiBaseUrl}/branding/${encodeURIComponent(companyCode)}/${asset}`;
}

// Preloads a company's logo/favicon (if any) and swaps the browser tab icon
// in place -- both public endpoints 404 when branding isn't enabled, so a
// failed preload just means "keep the default look," not an error. Used by
// the authenticated dashboard (company known from the session) and by
// public pages that resolve a company from a token (invite/badge links).
export function useCompanyBranding(companyCode: string | undefined): { logoUrl: string | null } {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!companyCode) return;

    let cancelled = false;
    const logo = new Image();
    logo.onload = () => {
      if (!cancelled) setLogoUrl(brandingUrl(companyCode, "logo"));
    };
    logo.src = brandingUrl(companyCode, "logo");

    const favicon = new Image();
    favicon.onload = () => {
      if (cancelled) return;
      const link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
      if (link) link.href = brandingUrl(companyCode, "favicon");
    };
    favicon.src = brandingUrl(companyCode, "favicon");

    return () => {
      cancelled = true;
      setLogoUrl(null);
      const link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
      if (link) link.href = DEFAULT_FAVICON_HREF;
    };
  }, [companyCode]);

  return { logoUrl };
}
